import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  fetchBusinessCustomers,
  fetchSingleBusinessCustomer,
  restrictBusinessCustomer,
  unrestrictBusinessCustomer,
} from "./thunkActions";

interface InitialState {
  isLoading: boolean;
  businessCustomers: IBusinessCustomers | null;
  singleBusinessCustomer: IBusinessCustomerDetails | null;
  isFetchingBusinessCustomerDetails: boolean;
  isUpdatingBusinessCustomer: boolean;
}

const initialState: InitialState = {
  isLoading: false,
  isFetchingBusinessCustomerDetails: false,
  isUpdatingBusinessCustomer: false,
  businessCustomers: null,
  singleBusinessCustomer: null,
};

export const businessCustomersSlice = createSlice({
  name: "businessCustomers",
  initialState,
  reducers: {
    clearBusinessCustomersData: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.businessCustomers = null;
      }
    },
    clearBusinessCustomer: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.singleBusinessCustomer = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessCustomers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBusinessCustomers.fulfilled, (state, action) => {
        state.businessCustomers = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchBusinessCustomers.rejected, (state) => {
        state.isLoading = false;
      });
    builder
      .addCase(fetchSingleBusinessCustomer.pending, (state) => {
        state.isFetchingBusinessCustomerDetails = true;
      })
      .addCase(fetchSingleBusinessCustomer.fulfilled, (state, action) => {
        state.singleBusinessCustomer = action.payload;
        state.isFetchingBusinessCustomerDetails = false;
      })
      .addCase(fetchSingleBusinessCustomer.rejected, (state) => {
        state.isFetchingBusinessCustomerDetails = false;
      });
    builder
      .addMatcher(
        (action) =>
          [
            restrictBusinessCustomer.pending.type,
            unrestrictBusinessCustomer.pending.type,
          ].includes(action.type),
        (state) => {
          state.isUpdatingBusinessCustomer = true;
        }
      )
      .addMatcher(
        (action) =>
          [
            restrictBusinessCustomer.fulfilled.type,
            restrictBusinessCustomer.rejected.type,
            unrestrictBusinessCustomer.fulfilled.type,
            unrestrictBusinessCustomer.rejected.type,
          ].includes(action.type),
        (state) => {
          state.isUpdatingBusinessCustomer = false;
        }
      );
  },
});

export default businessCustomersSlice.reducer;
export const { clearBusinessCustomersData, clearBusinessCustomer } =
  businessCustomersSlice.actions;
export * from "./thunkActions";
